import React from 'react' // eslint-disable-line

import styled from 'styled-components'
const tabletWidth = 1200
const mobileWidth = 980
export const ShortcutsSubMenu = styled.div`
  width: 100%;
  margin: 60px 0;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  display: flex;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
    margin-left: 10px;
    padding: 0;
    border: solid 1px #000000;
    background: transparent;
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    cursor: pointer;
    &:focus {
      outline: 0;
    }
    &[data-style='hide'] {
      display: none;
    }
    a {
      text-decoration: none;
      color: #000000;
      padding: 8px 16px;
    }
  }
  @media (max-width: ${mobileWidth}px) {
    justify-content: flex-start;
  }
  @media (max-width: ${tabletWidth}px) {
    margin: 36px 0;
    button:first-child {
      margin-left: 10px;
    }
    button:last-child {
      margin-right: 10px;
    }
    overflow-x: scroll;
    flex-wrap: nowrap;
    //justify-content: flex-start;
    white-space: nowrap;
    ::-webkit-scrollbar {
      display: none;
    }
    button {
      padding: 0;
      height: 28px;
      font-size: 12px;
      a {
        padding: 7px 16px;
      }
    }
  }
`